import React from 'react'
import { createRoot } from 'react-dom/client'

import { App, AppProps } from './app/App'

document
  .querySelectorAll<HTMLElement>('.smart-guide-app[data-props]')
  .forEach((el) => {
    const json = el.getAttribute('data-props') || '{}'
    const props = JSON.parse(json) as AppProps
    const root = createRoot(el)
    root.render(<App {...props} />)
  })
